// BalajiDoc.jsx
import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import balajidoc from '../../../../assets/images/Doctorsimages/BALAJIDR.png'
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const BalajiDoc = () => {
  const navigate = useNavigate(); 
   useEffect(() => {
       document.title = "Dr. Krishnamoorthy Balaji | Best Orthodontist & Dental Implant Specialist in Chennai & Bangalore | H-Cura Multispeciality Clinic";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Meet Dr. Krishnamoorthy Balaji, Senior Orthodontist & Implantologist with 33+ years of experience. Available at H-Cura Multispeciality Clinic (Chennai & Bangalore) for advanced braces, implants, and smile correction treatments."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "Dr Krishnamoorthy Balaji, Orthodontist in Chennai, Orthodontist in Bangalore, Dental Implant Specialist, Best Orthodontist in Chennai, Best Orthodontist in Bangalore, H-Cura Multispeciality Clinic, Invisible Braces in Chennai, Invisible Braces in Bangalore, Smile Correction Expert, Braces Specialist, Dental Implants Chennai, Dental Implants Bangalore, Advanced Dental Clinic, Dental Clinic in Chennai, Dental Clinic in Bangalore"
  );
}

        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-krishnamoorthy-balaji");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-krishnamoorthy-balaji");
          document.head.appendChild(canonicalLink);
        }
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);

const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');

  container.classList.add('veenadoc-pdf-mode');

  const originalStyles = new Map();

  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });

  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }

  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });

  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;

      const marginLeft = 10;
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;

      const scaleFactor = availableWidth / canvasWidth;

      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;

      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Krishnamoorthy_Balaji_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');

      container.classList.remove('veenadoc-pdf-mode');

      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Krishnamoorthy Balaji</span>
                  <span className="veenadoc-title-credentials">(BDS ,MDS)</span>
                  <span className="veenadoc-title-location">Chennai & Bangalore</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Dr. Krishnamoorthy Balaji is one of the best orthodontists in Chennai and among the best orthodontists in Bangalore, known for his dedication to precision dentistry and patient-first care. With over <strong>33 years</strong> of clinical excellence, He has transformed thousands of smiles through advanced orthodontic and implantology treatments.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
                    className="veenadoc-btn-primary-gradient"
                    onClick={() => navigate('/bookconsultation')}
                  >
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={balajidoc} alt="Dr. Krishnamoorthy Balaji - Best Orthodontist & Dental Implant Specialist in Chennai & Bangalore" className="veenadoc-doctor-image" title='Dr. Krishnamoorthy Balaji – Best Orthodontist & Dental Implant Specialist' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. Krishnamoorthy Balaji</h2>
                  <p>
                    Dr. Krishnamoorthy Balaji is one of the best orthodontists in Chennai and among the best orthodontists in Bangalore, known for his dedication to precision dentistry and patient-first care. With over 33 years of clinical excellence. He has transformed thousands of smiles through advanced orthodontic and implantology treatments.
                  </p>
                  <p>
                    A postgraduate of I.P. Pavlov State Medical University, Saint Petersburg (Russia), and certified by the American Academy of Implant Dentistry (AAID), Dr. Balaji combines international training with Indian clinical expertise to offer world-class dental results at H-Cura Multispeciality Clinic.
                  </p>
                  <p>
                    He has mastered the Straight Wire Technique under DENTAURUM, Germany, allowing him to deliver precise, aesthetic, and comfortable results for every patient seeking the best orthodontist near me or a trusted implantologist in India.
                  </p>
                </div>

                {/* Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Expertise and Specializations</h2>
                  <p>
                    As an experienced orthodontist in Chennai and experienced orthodontist in Bangalore, Dr. Balaji provides customized, holistic solutions for all age groups. His specialization includes:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li><strong>Orthodontics & Aligners:</strong> Invisible Braces, Ceramic Braces, Self-Ligating Braces, Clear Aligners</li>
                    <li><strong>Dental Implants:</strong> Advanced Implant Placement, All-on-4 Rehabilitation, Bone Grafting Procedures</li>
                    <li><strong>Dentofacial Orthopedics:</strong> Jaw Alignment & Facial Growth Correction</li>
                    <li><strong>Smile Design & Cosmetic Dentistry:</strong> Digital Smile Analysis and Aesthetic Reconstruction</li>
                    <li><strong>Preventive Dentistry:</strong> Early Intervention for Children and Teens</li>
                  </ul>
                  <p>
                    Each treatment is planned with cutting-edge digital diagnostics to ensure painless, predictable, and long-lasting outcomes. With over 1,500+ successfully documented orthodontic cases, patients consistently refer to him as the best orthodontist in Chennai and best orthodontist in Bangalore.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">Postgraduate, I.P. Pavlov State Medical University, Russia | AAID Certified</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">33+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Orthodontics & Dental Implants</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Chennai & Bangalore</span>
                    </div>
                  </div>
                </div>

                {/* Global Experience */}
                <div className="veenadoc-article-block">
                  <h2>Global Experience and Leadership</h2>
                  <p>
                    Dr. Balaji's expertise extends far beyond the clinic chair. He has held senior positions such as Regional Director – Operations (Tamil Nadu & Telangana) at Vasan Health Care, overseeing 19 centers and 450+ professionals, and later served as AGM & Zonal Clinical Head for Clove Dental Hospitals – South India.
                  </p>
                  <p>
                    His leadership background ensures that every patient visiting the H-Cura Multispeciality Clinic in Bangalore or Chennai receives care aligned with the highest standards of safety, ethics, and technology. He is widely regarded as an implantologist in India who integrates science, skill, and sensitivity in every procedure.
                  </p>
                </div>

                {/* Why Choose */}
                <div className="veenadoc-article-block">
                  <h2>Why Choose Dr. Balaji at H-Cura Multispeciality Clinic</h2>
                  <p>
                    Patients looking for the best orthodontist near me or a reliable dental implant specialist in Chennai prefer H-Cura Multispeciality Clinic because of Dr. Balaji's exceptional qualities:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>✅ 33 years of clinical mastery in Orthodontics and Implantology</li>
                    <li>✅ International training and evidence-based practice</li>
                    <li>✅ Advanced technology – 3D scanning, digital impressions, guided implants</li>
                    <li>✅ Personalized care with ethical diagnosis and counseling</li>
                    <li>✅ Pain-free and minimally invasive treatments</li>
                    <li>✅ Comprehensive after-care and long-term follow-ups</li>
                  </ul>
                  <p>
                    He ensures that every patient leaves the clinic with a confident smile and a healthier life — making him a top-rated orthodontist near me and one of the most sought-after implantologists in India.
                  </p>
                </div>

                {/* Role at H-Cura */}
                <div className="veenadoc-article-block">
                  <h2>Role at H-Cura Multispeciality Clinic</h2>
                  <p>
                    At H-Cura Multispeciality Clinic, Dr. Balaji leads the Advanced Dental & Orthodontic Division. Here, he works with a team of skilled dental professionals offering:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Orthodontic Correction for Teens & Adults</li>
                    <li>Dental Implants and Full-Mouth Rehabilitation</li>
                    <li>Aesthetic Smile Makeovers</li>
                    <li>Preventive Dental Care & Regular Check-ups</li>
                    <li>Digital Diagnostics & Patient Education</li>
                  </ul>
                  <p>
                    The clinic is equipped with world-class sterilization systems, 3D imaging, and personalized treatment protocols — ensuring patients in Bangalore and Chennai have access to the best dental implant doctor near me and the best orthodontist in Chennai under one roof.
                  </p>
                </div>

                {/* Philosophy */}
                <div className="veenadoc-article-block">
                  <h2>Dr. Balaji's Philosophy</h2>
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "A great smile is a lifetime investment. Dentistry is about more than teeth — it's about restoring confidence and function. My mission at H-Cura Multispeciality Clinic is to make global-standard dental care accessible to everyone in Bangalore and Chennai."
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Krishnamoorthy Balaji</p>
                  </div>
                </div>

                {/* Clinic Locations */}
                <div className="veenadoc-article-block">
                  <h2>Clinic Locations & Consultations</h2>
                  <p>Available at:</p>
                  <ul className="veenadoc-search-queries-list">
                    <li>🏢 H-Cura Multispeciality Clinic – Jayanagar, Bangalore</li>
                    <li>🏢 H-Cura Multispeciality Clinic – Extended care services,Chennai</li>
                    
                  </ul>
                  <p>
                    <strong>Consultation Options:</strong> Online and Offline (Appointment Based)
                  </p>
                  <p>
                    Patients searching for an orthodontist near me, dental specialist near me, or the best implantologist in India can easily connect with Dr. Balaji through H-Cura's online consultation system.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Book Your Appointment Today</h2>
                  <p>
                    Transform your smile with the best orthodontist in Bangalore and the best orthodontist in Chennai. Book an appointment with Dr. Krishnamoorthy Balaji at H-Cura Multispeciality Clinic to experience pain-free, aesthetic, and long-lasting dental solutions.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Call Now or Book Online – Your New Smile Awaits You!</strong>
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">🦷</div>
                    <blockquote>
                      "A great smile is a lifetime investment"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Balaji's Philosophy of Care</p>
                  </div>
                  <p>
                    Dentistry is about more than teeth — it's about restoring confidence and function. Dr. Balaji's mission at H-Cura Multispeciality Clinic is to make global-standard dental care accessible to everyone in Bangalore and Chennai.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Jayanagar, Bangalore</h4>
                      <p>H-Cura Multispeciality Clinic</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Extended care services,Chennai</h4>
                      <p>H-Cura Multispeciality Clinic</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Transform your smile with Dr. Balaji's expertise in orthodontics and dental implants.</p>
                  <button
                    className="veenadoc-sidebar-btn-primary"
                    onClick={() => window.location.href = 'tel:+919964688333'}
                  >
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button
                    className="veenadoc-sidebar-btn-secondary"
                    onClick={() => window.location.href = 'tel:+919964688333'}
                  >
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      {/* <AutoScrollImageRow/> */}

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Doctor profile as PDF
        </button>
      </div>
    </>
  )
}

export default BalajiDoc

